import React from 'react';
import { Route } from 'react-router-dom';
import UserScreen from '../screens/UserScreen';
import MarketingUserScreen from '../screens/MarketingUserScreen';
import SuperAdminUserScreen from '../screens/SuperAdminUserScreen';
import * as ROUTES from '../constants/routes';

function UserRoutes() {
  return (
    <>
      <Route path={ROUTES.USER} exact>
        <UserScreen />
      </Route>
      <Route path={ROUTES.MARKETING_USER} exact>
        <MarketingUserScreen />
      </Route>
      <Route
        path={ROUTES.SUPER_ADMIN_USER}
        exact
        component={() => <SuperAdminUserScreen />}
      />
    </>
  );
}

export default UserRoutes;
